import { AbstractLocalDataAccessLayer } from "@/lib/utility/data/local-data-access-layer.abstract";
import { IVideo, Video } from "@/models/video.entity";

export const VideoDataAccessLayer = new (class extends AbstractLocalDataAccessLayer<IVideo> {
  protected mapEntity(entity: IVideo): IVideo {
    return new Video(entity);
  }

  getIdentifier(entity: IVideo): string {
    return entity.id;
  }
})();
